import React, { useEffect, useRef } from "react";
import { addStyles, EditableMathField } from "react-mathquill";
import Button from "../../common/Button";

const Keypad = ( props ) => {

  const mathField = useRef();

  useEffect( addStyles, [] );

  const mountEditableMathField = ( bare ) => {
    mathField.current = bare;
  };

  const onClear = () => {
    mathField.current.latex( '' );
  };

  const onSubmit = () => {
    props.onSubmit( mathField.current.latex() );
  };

  const onKey = ( event ) => {
    mathField.current.write( event.target.dataset.latex );
  };

  const onArrow = ( event ) => {
    onClear();
    props.onArrow( `${ event.target.dataset.latex }?${ Date.now() }` );
  };

  const onChange = () => {
    props.onChange( 1 );
  };

  return (
    <div style={ { width : '60%' } }>
      <div style={ { padding : 5, display : 'inline-flex' } }>
        <EditableMathField style={ { width : 400, height : 300 } } latex="" mathquillDidMount={ mountEditableMathField } />
        <div style={ { paddingLeft : 5 } }>
          <Button className="btn btn-red" style={ { width : 100 } } onClick={ onClear }>Clear</Button>
          <br />
          <div style={ { height : 5 } } />
          <Button className="btn btn-red" style={ { width : 100 } } onClick={ onSubmit }>Submit</Button>
        </div>
      </div>
      <div style={ { padding : 5 } }>
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="1" onClick={ onKey }>1</Button>
        <span style={ { padding : 2.5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="2" onClick={ onKey }>2</Button>
        <span style={ { padding : 2.5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="3" onClick={ onKey }>3</Button>
        <br />
        <div style={ { height : 5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="4" onClick={ onKey }>4</Button>
        <span style={ { padding : 2.5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="5" onClick={ onKey }>5</Button>
        <span style={ { padding : 2.5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="6" onClick={ onKey }>6</Button>
        <br />
        <div style={ { height : 5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="7" onClick={ onKey }>7</Button>
        <span style={ { padding : 2.5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="8" onClick={ onKey }>8</Button>
        <span style={ { padding : 2.5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="9" onClick={ onKey }>9</Button>
        <br />
        <div style={ { height : 5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex="<" onClick={ onArrow }>{ '<' }</Button>
        <span style={ { padding : 2.5 } } />
        <Button className="btn btn-blue" style={ { width : 60 } } data-latex=">" onClick={ onArrow }>{ '>' }</Button>
        <br />
        <div style={ { height : 5 } } />
        <Button className="btn btn-red" style={ { width : 195 } } onClick={ onChange }>Keypad Change</Button>
      </div>
    </div>
  );

};

export default Keypad;
